import {
  MdHandshake,
  MdOutlineGroups,
  MdOutlineShield,
  MdOutlineVerified,
  MdCheckCircle,
} from "react-icons/md";
import { principles, strengths } from "../ones/RunzeweContent";

const strengthIcons = [
  <MdOutlineShield />,
  <MdOutlineGroups />,
  <MdOutlineVerified />,
  <MdHandshake />,
];

export default function HomeAbout() {
  return (
    <section className="home-about-section">
      <div className="container">
        <div className="home-about-grid">
          <div className="home-about-copy" data-aos="fade-right">
            <p className="section-kicker">About Runzewe Security</p>
            <h2>Your Security. Our Commitment.</h2>
            <p>
              Runzewe Security Company Limited is a fully registered Tanzanian
              private security provider committed to excellence, reliability, and
              integrity. We combine trained personnel with technical security
              solutions to deliver responsive protection across diverse
              industries.
            </p>

            <div className="strength-grid">
              {strengths.map((item, index) => (
                <div className="strength-item" key={item.title} data-aos="fade-up" data-aos-delay={index * 70}>
                  <div>{strengthIcons[index]}</div>
                  <strong>{item.title}</strong>
                </div>
              ))}
            </div>
          </div>

          <div className="principles-list" data-aos="fade-left">
            {principles.map((item, index) => (
              <div className="principle-item" key={item.title} data-aos="fade-up" data-aos-delay={index * 90}>
                <MdCheckCircle />
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
